import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { c, h } from '@debbie/cortex/dist/index.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import CasePreview from './CasePreview/index.js';
import VoucherCreator from './economy/CaseBilling/VoucherCreator.js';
import PlaceholderLoader from './PlaceholderLoader.js';
import Search from './Search.js';
import { useVoucherTypes } from '@debbie/cortex/dist/voucher-types/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
const AddBillingVoucher = (props) => {
    const voucherTypesLoadable = useVoucherTypes();
    const voucherTypes = h.hasData(voucherTypesLoadable)
        ? voucherTypesLoadable.data
        : null;
    const [caseId, setCaseId] = useState(props.caseId);
    const singleCase = useSelector((s) => caseId ? selectCaseById(s, caseId) : null);
    useEffect(() => {
        if (caseId && !singleCase) {
            c.cases.getById(caseId);
        }
    }, [caseId]);
    return (React.createElement("div", null,
        !props.caseId && (React.createElement(Search, { removeWrapper: true, onSelect: (res) => {
                console.log(res);
                setCaseId(res.objectID);
            } })),
        caseId &&
            (singleCase ? (React.createElement(React.Fragment, null,
                !props.caseId && (React.createElement("p", null,
                    React.createElement(CasePreview, { caseId: singleCase.id }))),
                React.createElement(VoucherCreator, { caseId: caseId, tenantId: singleCase.tenantId, creditorId: singleCase.creditorId, currency: singleCase.currency, types: (voucherTypes || []).filter((voucherType) => [VoucherCategory.FEE, VoucherCategory.DISBURSEMENT].includes(voucherType.category)), onAdd: props.onAdd }))) : (React.createElement(PlaceholderLoader, null)))));
};
export default AddBillingVoucher;
//# sourceMappingURL=AddBillingVoucher.js.map